import { render, staticRenderFns } from "./RelatorioListPreview.vue?vue&type=template&id=3497c28c&scoped=true"
import script from "./RelatorioListPreview.vue?vue&type=script&lang=js"
export * from "./RelatorioListPreview.vue?vue&type=script&lang=js"
import style0 from "./RelatorioListPreview.vue?vue&type=style&index=0&id=3497c28c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3497c28c",
  null
  
)

export default component.exports